<div class="stc-modal" [attr.attribute-open]="isOpen">
  <div class="stc-modal-body" [ngClass]="width">
    <ng-content></ng-content>
  </div>
</div>